import { setVisitorState } from "../store/reducers/visitorReducer";
import { store } from "../store/store";
import storage from "redux-persist/lib/storage";

export const syncTabs = () => {
  window.addEventListener("storage", async (event) => {
    if (event.key === "persist:root") {
      const newPersistedState = await storage.getItem("persist:root");
      if (newPersistedState) {
        const parsedState = JSON.parse(newPersistedState);
        const newVisitorState = JSON.parse(parsedState.visitor);
        // Dispatch the updated visitor state
        if (newVisitorState) {
          store.dispatch(setVisitorState(newVisitorState));
        }
      }
    }
  });
};
